import { REDUCER_NAME_FEEDBACK_FORMS } from 'utils/enums/reducersNames'
import { feedbackFormsSchema } from 'store/entities/feedbackForms/FeedbackFormsSchema'
import { transformResponsePayload } from 'utils/helpers/applicationForm'
import { actionsCreators } from 'store/common'

const creatorSettings = {
  entityUrl: '',
  entityKey: REDUCER_NAME_FEEDBACK_FORMS,
  entitySchema: feedbackFormsSchema,
  transformResponseFunction: entity => transformResponsePayload(entity),
}

export const fetchFeedbackFormById = actionsCreators.makeFetchItem({
  ...creatorSettings,
  entityUrl: '/public/forms?uuid=$id$',
})

export const submitFeedbackForm = actionsCreators.makeCreateItem({
  ...creatorSettings,
  entityUrl: '/public/forms',
})
